var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('segment-edit',{attrs:{"segment":_vm.segment}}),_c('segment-job-board',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"segment":_vm.segment,"job-boards":_vm.mappedJobBoards}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }